"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERequestStatus = exports.ERequestCommand = exports.ESocketCallbackStep = void 0;
var ESocketCallbackStep;
(function (ESocketCallbackStep) {
    ESocketCallbackStep[ESocketCallbackStep["Unknown"] = 0] = "Unknown";
    ESocketCallbackStep[ESocketCallbackStep["Init"] = 1] = "Init";
    ESocketCallbackStep[ESocketCallbackStep["Connected"] = 2] = "Connected";
    ESocketCallbackStep[ESocketCallbackStep["Error"] = 3] = "Error";
    ESocketCallbackStep[ESocketCallbackStep["Close"] = 4] = "Close";
    ESocketCallbackStep[ESocketCallbackStep["Kill"] = 5] = "Kill";
    ESocketCallbackStep[ESocketCallbackStep["Reconnection"] = 6] = "Reconnection";
    ESocketCallbackStep[ESocketCallbackStep["SchemeNotFound"] = 7] = "SchemeNotFound";
    ESocketCallbackStep[ESocketCallbackStep["DecodedInfo"] = 8] = "DecodedInfo";
})(ESocketCallbackStep || (exports.ESocketCallbackStep = ESocketCallbackStep = {}));
var ERequestCommand;
(function (ERequestCommand) {
    ERequestCommand["GetLotteries"] = "client_lotteries";
    ERequestCommand["BuyLottery"] = "bet_lottery_ticket";
    ERequestCommand["HistoryLottery"] = "betlotteries";
    ERequestCommand["AuthByToken"] = "clienttoken";
    ERequestCommand["AuthByLogin"] = "clientlogin";
    ERequestCommand["UserData"] = "betlogin";
    ERequestCommand["GeoProviders"] = "client_slotegrator_geo_provider";
    ERequestCommand["LogOut"] = "clientlogout";
    ERequestCommand["DemoInit"] = "client_slotegrator_demo_init";
    ERequestCommand["GameInit"] = "bet_slotegrator_game_init";
    ERequestCommand["Registration"] = "clientregister";
    ERequestCommand["ClientSms"] = "clientsms";
    ERequestCommand["ClientSmsEmail"] = "clientsms_email";
    ERequestCommand["BetBitoloDeposit"] = "bet_bitolo_create_deposit";
    ERequestCommand["BetPaykassmaActiveOne"] = "bet_paykassma_deposit_active_step1";
    ERequestCommand["PaykassmaDepositActiveTwo"] = "bet_paykassma_deposit_active_step2";
    ERequestCommand["PaykassmaCreateWithdraw"] = "bet_paykassma_create_withdraw";
    ERequestCommand["BetInstaPaysCreateWithdraw"] = "bet_instapays_create_withdraw";
    ERequestCommand["BetPayAnindaCreateWithdraw"] = "bet_payaninda_create_withdraw";
    ERequestCommand["BitoloWithdraw"] = "bet_bitolo_create_withdraw";
    ERequestCommand["BetPayheraCreateWithdraw"] = "bet_payhera_create_withdraw";
    ERequestCommand["UserTag"] = "client_utm_content";
    ERequestCommand["BetHistory"] = "bethistory";
    ERequestCommand["BetGameFlow"] = "betgameflow";
    ERequestCommand["BetOperation"] = "betoperation";
    ERequestCommand["ClientCodePass"] = "clientcodepass";
    ERequestCommand["BetCancelPayment"] = "betcancelpayment";
    ERequestCommand["RequestMax"] = "betlimits";
    ERequestCommand["ExtraLines"] = "extralines";
    // TODO FIX IT SendBets
    ERequestCommand["MultiTicket"] = "multiticket";
    ERequestCommand["ClientPsw"] = "clientnewpass";
    ERequestCommand["\u0421lient\u0421ode"] = "clientcode";
    ERequestCommand["BetPaykassmaDeposit"] = "bet_paykassma_create_deposit";
    ERequestCommand["BetInstapaysCreateDeposit"] = "bet_instapays_create_deposit";
    ERequestCommand["BetPayAnindaCreateDeposit"] = "bet_payaninda_create_deposit";
    ERequestCommand["BetPayfixCreateDeposit"] = "bet_payfix_create_deposit";
    ERequestCommand["BetPayheraCreateDeposit"] = "bet_payhera_create_deposit";
    ERequestCommand["CurrencyProvider"] = "client_slotegrator_currency_provider";
    ERequestCommand["GetUserGeoAndCurrency"] = "client_slotegrator_geo_currency";
    // TODO FIX IT MultiTicket
    ERequestCommand["SendBets"] = "multiticket";
    ERequestCommand["ClientTournament"] = "client_casino_tournament";
    // TODO walletxPay rename
    ERequestCommand["ClientSettings"] = "clientfavorites";
    ERequestCommand["BetPagsmileDep"] = "bet_pagsmile_create_deposit";
    ERequestCommand["BetPagsmileWithdraw"] = "bet_pagsmile_create_withdraw";
    ERequestCommand["BetManual"] = "bet_manual_deposit";
    ERequestCommand["BetBonusPack"] = "betbonuspack";
    ERequestCommand["TournamentUserInfo"] = "client_place";
    ERequestCommand["BetLoyaltyPage"] = "bet_loyality_page";
    ERequestCommand["StartBetting"] = "startbet";
    ERequestCommand["StopBetting"] = "stopbet";
    // Rubles
    ERequestCommand["RublesDeposit"] = "bet_payment_create_deposit";
    ERequestCommand["BetPaymentCreateWithdraw"] = "bet_payment_create_withdraw";
    ERequestCommand["BetPaymentCreateDeposit"] = "bet_payment_create_deposit";
    ERequestCommand["ClientAfterRegister"] = "client_after_register";
    ERequestCommand["ClientFlashCall"] = "clientflashcall";
})(ERequestCommand || (exports.ERequestCommand = ERequestCommand = {}));
// ============== END MARKETS ==============
var ERequestStatus;
(function (ERequestStatus) {
    ERequestStatus[ERequestStatus["Unknown"] = 0] = "Unknown";
    ERequestStatus[ERequestStatus["Requesting"] = 1] = "Requesting";
    ERequestStatus[ERequestStatus["Success"] = 2] = "Success";
    ERequestStatus[ERequestStatus["Rejected"] = 3] = "Rejected";
})(ERequestStatus || (exports.ERequestStatus = ERequestStatus = {}));
